import _ from 'lodash';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import React from 'react';
import { Typography } from '@mui/material';
import { FieldValues, Path, Controller } from 'react-hook-form';
import { FormHookProps } from 'src/types/Commons/form-hook';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _TextFieldFormHook(props: any) {
  const importedProps = _.pick(props, [
    'autoComplete',
    'autoFocus',
    'children',
    'className',
    'defaultValue',
    'disabled',
    'FormHelperTextProps',
    'fullWidth',
    'id',
    'InputLabelProps',
    'inputProps',
    'InputProps',
    'inputRef',
    'label',
    'multiline',
    'name',
    'onBlur',
    'onChange',
    'onFocus',
    'placeholder',
    'required',
    'rows',
    'rowsMax',
    'select',
    'SelectProps',
    'type',
    'variant',
    'value',
    'onClick'
  ]);

  const { errorMessage, register, options, name, hideErrorMessage } = props;
  importedProps.InputLabelProps = { shrink: true };
  return (
    <>
      <TextField {...register(name, options)} {...importedProps} />

      {errorMessage && !hideErrorMessage && (
        <Typography variant="inherit" className="text-red-500">
          {errorMessage}
        </Typography>
      )}
    </>
  );
}
const TextFieldFormHook = React.memo(_TextFieldFormHook) as typeof _TextFieldFormHook;
export default TextFieldFormHook;

export interface TextFieldFormHookV2Props<TField extends FieldValues> extends FormHookProps<TField> {
  name: Path<TField>;
  label: string;
  [key: string]: any;
  styleFormControl?: { [key: string]: string };
}
function _TextFieldFormHookV2<TFieldValues extends FieldValues = FieldValues>(
  props: TextFieldFormHookV2Props<TFieldValues> & TextFieldProps
) {
  type TextFieldPropsKeys = keyof TextFieldProps;
  const importedProps = _.pick(props, Object.keys(props) as TextFieldPropsKeys[]);
  importedProps.InputLabelProps = { shrink: true };

  const { error } = props.control.getFieldState(props.name);
  return (
    <>
      <Controller
        control={props.control}
        name={props.name}
        rules={props.rules}
        render={({ field: { onChange, value }, fieldState: { error } }) => {
          return (
            <TextField
              error={error !== undefined}
              value={value}
              onChange={e => {
                onChange(e.target.value);
                props.onChange && props.onChange(e);
              }}
              {...importedProps}
            />
          );
        }}
      />
      {error?.message && (
        <Typography variant="inherit" className="text-red-500">
          {error.message}
        </Typography>
      )}
    </>
  );
}
export const TextFieldFormHookV2 = React.memo(_TextFieldFormHookV2) as typeof _TextFieldFormHookV2;
